import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/iconfont/iconfont.css"
import ElementUI from 'element-ui';
import './element-variables.scss'
import {message} from "./assets/js/resetMessage"
import {getSurplus} from "./utils/index"
import "./utils/move"
import hevueImgPreviewf from "hevue-img-preview";
if(localStorage.getItem("uinfo")){
  store.commit("info",JSON.parse(localStorage.getItem("uinfo")))
}
Vue.config.productionTip = false
Vue.prototype.$getSurplus = getSurplus
// 事件总线，实现兄弟组件传值
Vue.prototype.$bus=new Vue()
Vue.use(ElementUI)
Vue.use(hevueImgPreviewf)
Vue.prototype.$message=message
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
